<template>
	<!-- 订单详情-车主信息 -->
	<div class="car-owner-info">
		<div class="car-owner-info__top">
			<nio-header-nav
				position="fixed"
				:is-white="true"
				@back="handleBack"
				:height.sync="headerHeight"
			>
				<template v-slot:default>
					<nio-button
						text="修改信息"
						@click="edit"
						type="btn_solid_l_bg"
						v-if="canEdit === '2'"
					></nio-button>
				</template>
			</nio-header-nav>
		</div>

		<div
			class="car-owner-info-main"
			:style="{
				paddingTop: headerHeight + 15 + 'px',
				paddingBottom: insetBottom + 'px'
			}"
		>
			<div class="car-owner-info-main-title">
				购车信息
			</div>
			<div
				class="car-owner-info-main-content
      "
			>
				请按照购车类型和交付地点完善信息。车主即车辆产权所有人，关联购车协议、车辆行驶证、机动车发票、金融贷款、电池租赁、上牌资质等
			</div>
			<div class="car-owner-info-main-title__sub-title">购买信息</div>
			<owner-info-form v-model="formData" ref="ownerInfoForm" v-show="!showList || currentEdit" />
			<nio-button
				text="保存信息"
				v-show="!showList || currentEdit"
				@click="submit"
				:disabled="disabled"
			></nio-button>
			<info-list :list="infoList" v-show="showList && !currentEdit" />
		</div>
	</div>
</template>

<script>
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import InfoList from './InfoList'
import OwnerInfoForm from '@/components/OwnerInfoForm.vue'
import { getOwnerInfo, editOwnerInfo } from '@/model'
import { cardType, carOwnerInfoOptions } from './conf'
import { supreme } from '@/supreme-core'
export default {
	name: 'carOwnerInfo',
	components: { InfoList, OwnerInfoForm },
	data() {
		return {
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			formData: {
				//订单号
				orderNo: '',
				//车辆所有人类型
				ownerType: null,
				//车辆所有人姓名
				ownerName: '',
				//车辆所有人手机号
				ownerPhone: '',
				ownerIdCode: '',
				cardTypeInfo: null,
				registerCityInfo: null
			},
			canEdit: null,
			taskStatus: null,
			currentEdit: false,
			infoList: []
		}
	},
	computed: {
		showList() {
			return this.canEdit === '2' || this.canEdit === '3'
		},
		disabled: function() {
			const {
				orderNo,
				ownerIdCode,
				ownerIdType,
				ownerName,
				ownerPhone,
				ownerType,
				registerCityInfo,
				cardTypeInfo
			} = this.formData
			if (
				ownerType &&
				ownerType === 1 &&
				ownerName &&
				ownerPhone &&
				cardTypeInfo &&
				registerCityInfo
			) {
				return false
			} else if (
				ownerType &&
				ownerType === 2 &&
				ownerIdCode &&
				ownerName &&
				registerCityInfo
			) {
				return false
			} else {
				return true
			}
		}
	},
	created() {
		const orderNo = supreme.getQueryString('order_no')
		this.canEdit = supreme.getQueryString('can_edit')
		this.taskStatus = supreme.getQueryString('task_status')
		if (orderNo) {
			this.getOwnerInfo(orderNo)
		}
	},

	methods: {
		handleBack() {
			nativeHybrid.closeSyn()
		},
		getOwnerInfo(orderNo) {
			getOwnerInfo
				.get({}, `/${orderNo}/owner`)
				.then(res => {
					const { data } = res
					if (!data || data.result_code != 'success') {
						let error = {}
						error.message = data.debug_msg || data.display_msg
						throw error
					}
					const result = data.data

					this.infoList = carOwnerInfoOptions(result.owner_type)
					this.infoList = this.infoList.map(item => {
						item.value = result[item.key]
							? item.formatFn
								? item.formatFn(result[item.key])
								: result[item.key]
							: ''
						return item
					})

					const {
						order_no,
						owner_id_code,
						owner_id_type,
						owner_name,
						owner_phone,
						owner_type,
						registration_city,
						registration_city_name,
						registration_province,
						registration_province_name
					} = result

					this.formData.ownerType = owner_type ? owner_type : 1

					this.formData.ownerPhone = owner_phone
					this.formData.ownerName = owner_name
					this.formData.registerCityInfo = {
						province: {
							name: registration_province_name,
							area_code: registration_province
						},
						city: {
							name: registration_city_name,
							area_code: registration_city
						}
					}
					this.formData.cardTypeInfo = {
						value: owner_id_type,
						name: cardType[owner_id_type]
					}

					this.formData.orderNo = order_no
					this.formData.ownerIdCode = owner_id_code
				})
				.catch(err => {
					this.$toast(err.message)
				})
		},
		submit() {
			this.$refs.ownerInfoForm.$refs.Form.validate()
				.then(() => {
					const {
						ownerType,
						ownerName,
						ownerPhone,
						ownerIdCode,
						registerCityInfo,
						cardTypeInfo,
						...rest
					} = this.formData

					let params = {}
					if (ownerType === 1) {
						params = {
							order_no: this.formData.orderNo,
							owner_name: ownerName,
							owner_phone: ownerPhone,
							owner_id_type: cardTypeInfo.value,
							owner_id_code: ownerIdCode,
							owner_type: ownerType,
							register_city: registerCityInfo.city.area_code
						}
					} else {
						params = {
							order_no: this.formData.orderNo,
							owner_name: ownerName,
							owner_id_type: 7,
							owner_id_code: ownerIdCode,
							owner_type: ownerType,
							register_city: registerCityInfo.city.area_code
						}
					}

					editOwnerInfo
						.post(params)
						.then(res => {
							console.log(res)
							const { data } = res
							if (!data || data.result_code !== 'success') {
								let error = {}
								error.message = data.debug_msg || data.display_msg
								throw error
							}

							this.$toast('保存成功')
							if (this.canEdit === '2') {
								this.currentEdit = false
							} else {
								this.canEdit = '2'
							}
						})
						.catch(err => {
							console.log(err)
							this.$toast(err.message)
						})
				})
				.catch(err => {
					console.log(err)
				})
		},
		edit() {
			this.currentEdit = true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.car-owner-info {
	font-family: 'PingFang SC';
	&-main {
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		::v-deep {
			.nio-field {
				width: 100%;
			}
			.nio-select {
				width: 100%;
			}
			.nio-sheet {
				&__header {
					padding: 12px 20px 12px 20px;
					height: 50px;
					@include subtitle_2(1.4, 700, false);
					color: $text_primary;
				}
				&__content {
					@include body_1(1.5, 400, false);
					padding: 20px;
				}
			}

			.van-cell {
				padding: 0 0;
				&::after {
					display: none;
				}
			}
		}
		&-title {
			@include headline_1(1.4, 400, false);
			color: $text_primary;
			margin-bottom: 10px;
			&__sub-title {
				@include subtitle_2(1.4, 700, false);
				color: $text_primary;
				margin-bottom: 35px;
			}
		}
		&-content {
			@include subtitle_3(1.5, 400, false);
			color: $text_primary;
			margin-bottom: 60px;
		}
	}
}
</style>
